import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useMemo, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { AddAttendenceAPI, getLatestBreak, getSingleAttendence, updateAttendenceAPI } from "../../API/Api";
import { resetCallState, setLastSession, setLatestBreak, setLogin,setUserDetails } from "../../Redux/Slice/LoginSlice";
import { formBtn1 } from "../Utils/CustomClasses";
import { useNavigate } from "react-router-dom";
import { IconExclamationCircle,IconCircleCheck } from "@tabler/icons-react";
import { renderToString } from "react-dom/server";

export default function SessionModel({ checked, breaks, tog, change, log }) {

    const userDetails = useSelector((state) => state?.login?.userDetails);
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [selectedBreakType, setSelectedBreakType] = useState("");
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const loginDetails = useSelector((state) => state?.login?.lastSession);
    const latestBreak = useSelector((state) => state?.login?.latestBreak);

    const {
        register,
        handleSubmit,
        reset,
        watch,
    } = useForm();
    const com = watch("break_type");

    useMemo(() => {
        if (loginDetails) {
            if (loginDetails?.inTime && loginDetails?.outTime) {
                tog(false);
            } else if (loginDetails?.inTime && !loginDetails?.outTime) {
                tog(true);
            }

            if (latestBreak) {
                if (latestBreak?.inTime && !latestBreak?.outTime) {
                    console.log('break is on')
                    tog(false);
                    setIsLoggedIn(true);
                    setSelectedBreakType(latestBreak?.break_type);
                } else if (latestBreak?.inTime && latestBreak?.outTime && !loginDetails?.outTime) {
                    console.log('break is off')
                    tog(true);
                }
            }
        } else {
            tog(false);
        }
    }, [loginDetails, latestBreak])

    const loginHandler = () => {
        setIsLoggedIn(!isLoggedIn);
        breaks();
    };


    const toggle = () => {
        setSelectedBreakType("");
        change(!checked);
    };

    useMemo(() => {
        if (com == "Other") {
            setSelectedBreakType(com);
        } else {
            setSelectedBreakType(com);
        }
    }, [com]);

    const EndSession = async () => {
  try {
    let userPayload = {
      userId: userDetails._id,
      companyId: userDetails?.company?._id
    };

    await updateAttendenceAPI(userPayload).then(async res => {

      if (res.status == 201) {

        await getSingleAttendence(userDetails?._id).then((res) => {
          if (res?.status == 200) {
            dispatch(setLastSession(res?.data?.data));
          }
        });

        Swal.fire({
          html: `
            <div class="flex flex-col items-center gap-2 -mt-4">

              <div class="w-[120px] h-[120px] bg-[#E6FAEE] rounded-full flex items-center justify-center">
                ${renderToString(
                  <IconCircleCheck size={64} color="#22C55E" />
                )}
              </div>

              <h2 class="text-[28px] font-bold text-[#4A5565] leading-[140%]">
                Success
              </h2>

              <p class="text-[20px] font-medium text-[#4A5565] text-center">
                Session End Successfully!
              </p>

            </div>
          `,
          confirmButtonText: "OK",
          buttonsStyling: false,
          customClass: {
            popup: "rounded-xl px-6 py-4",
            actions: "flex justify-center mt-4",
            confirmButton:
              "w-[100px] h-[44px] bg-[var(--bg-base-color)] text-white rounded-md flex items-center justify-center",
          },
        }).then((willLogout) => {

          if (willLogout) {
            localStorage.clear();
            dispatch(setLogin(false));
            dispatch(setUserDetails([]));
            dispatch(resetCallState());
            navigate('');
          }

        });

        change(false);
        tog(false);

      } else {

        Swal.fire({
          html: `
            <div class="flex flex-col items-center gap-2 -mt-4">

              <div class="w-[120px] h-[120px] bg-[#FEF9C2] rounded-full flex items-center justify-center">
                ${renderToString(
                  <IconExclamationCircle size={64} color="#F59E0B" />
                )}
              </div>

              <h2 class="text-[28px] font-bold text-[#4A5565]">
                Warning
              </h2>

              <p class="text-[20px] font-medium text-[#4A5565] text-center">
                Session Not Ended
              </p>

            </div>
          `,
          confirmButtonText: "OK",
          buttonsStyling: false,
          customClass: {
            popup: "rounded-xl px-6 py-4",
            actions: "flex justify-center mt-4",
            confirmButton:
              "w-[100px] h-[44px] bg-[var(--bg-base-color)] text-white rounded-md flex items-center justify-center",
          },
        });

      }

    });

  } catch (err) {
    console.log("err", err);
  }
};
    const Break = async (data) => {
  const userdata = {
    userId: userDetails._id,
    company: userDetails?.company?._id,
    break_type: data?.break_type,
    break: "true",
  };
  try {
    AddAttendenceAPI(userdata).then(async (res) => {
      if (res.status == 201) {
        Swal.fire({
          html: `
            <div class="flex flex-col items-center gap-2 -mt-4">

              <div class="w-[120px] h-[120px] bg-[#E6FAEE] rounded-full flex items-center justify-center">
                ${renderToString(
                  <IconCircleCheck size={64} color="#22C55E" />
                )}
              </div>

              <h2 class="text-[32px] font-bold text-[#4A5565] leading-[140%]">
                Success
              </h2>

              <p class="text-[22px] font-medium text-[#4A5565] text-center">
                Break Added Successfully!
              </p>

            </div>
          `,
          confirmButtonText: "OK",
          buttonsStyling: false,

          customClass: {
            popup: "rounded-xl px-6 py-4",
            actions: "flex justify-center mt-4",

            confirmButton:
              "w-[100px] h-[44px] bg-[var(--bg-base-color)] text-white rounded-md flex items-center justify-center",
          },
        });

        change(false);
        tog(false);
        setIsLoggedIn(!isLoggedIn);
        await getLatestBreak(userDetails?._id).then((res) => {
          if (res.status === 200) {
            dispatch(setLatestBreak(res?.data?.data));
          }
        })
      } else {
        tog(true);
        Swal.fire({
          html: `
            <div class="flex flex-col items-center gap-2 -mt-4">

              <div class="w-[120px] h-[120px] bg-[#FEF9C2] rounded-full flex items-center justify-center">
                ${renderToString(
                  <IconExclamationCircle size={64} color="#F59E0B" />
                )}
              </div>

              <h2 class="text-[32px] font-bold text-[#4A5565]">
                Warning
              </h2>

              <p class="text-[22px] font-medium text-[#4A5565] text-center">
                ${res?.response?.data?.error}
              </p>

            </div>
          `,
          confirmButtonText: "OK",
          buttonsStyling: false,

          customClass: {
            popup: "rounded-xl px-6 py-4",
            actions: "flex justify-center mt-4",

            confirmButton:
              "w-[100px] h-[44px] bg-[var(--bg-base-color)] text-white rounded-md flex items-center justify-center",
          },
        });
      }
    });
  } catch (err) {
    console.log("err", err);
  }
};

const submit = (data) => {

  const showConfirm = (message, callback) => {
    Swal.fire({
      html: `
        <div class="flex flex-col items-center gap-2 -mt-4">

          <div class="w-[120px] h-[120px] bg-[#FEF9C2] rounded-full flex items-center justify-center">
            ${renderToString(
              <IconExclamationCircle size={64} color="#F59E0B" />
            )}
          </div>

          <h2 class="text-[32px] font-bold text-[#4A5565] leading-[140%] font-[Nata Sans]">
            Warning
          </h2>

          <p class="text-[24px] font-medium text-[#4A5565] leading-[140%] text-center">
            ${message}
          </p>

        </div>
      `,
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      buttonsStyling: false,

      customClass: {
        popup: "rounded-xl px-6 py-4",
        actions: "flex justify-center gap-4 mt-2",

        confirmButton:
        "w-[100px] h-[48px] bg-[var(--bg-base-color)] text-white rounded-[4px] flex items-center justify-center",

        cancelButton:
        "w-[100px] h-[48px] bg-white border border-[color:var(--bg-base-color)] text-[var(--bg-base-color)] rounded-[4px] flex items-center justify-center",
        },
    }).then(({ isConfirmed }) => {
      if (isConfirmed) {
        callback();
      } else {
        tog(true);
      }
    });
  };

  if (data.break_type === "sessionLogout") {
    change(false);

    showConfirm(
      "Do you want to End your Session",
      EndSession
    );

  } else {
    tog(false);
    change(false);

    showConfirm(
      `Reconfirm that you are on ${data.break_type} Break!!`,
      () => Break(data)
    );
  }

  reset();
};
    const cancelButtonRef = useRef(null);

    return (
      <>
        <Transition.Root
          show={isLoggedIn}
          size="md"
          centered
          className="modalstyle"
        >
          <Dialog
            as="div"
            className="relative z-[99]"
            initialFocus={cancelButtonRef}
            onClose={change}
          >
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-black bg-opacity-25 transition-opacity" />
            </Transition.Child>

            <div className="fixed inset-0 z-[99] overflow-y-auto">
              <div className="flex min-h-full items-center justify-center p-4 text-center">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  enterTo="opacity-100 translate-y-0 sm:scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                  leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                  <Dialog.Panel className="relative transform overflow-hidden rounded-2xl bg-white text-center shadow-[0_20px_60px_rgba(0,0,0,0.18)] transition-all w-full max-w-md px-8 py-8">
                    <div className="mt-1">
                      <Dialog.Title
                        as="h2"
                        className="text-[26px] font-semibold text-[var(--bg-base-color)] mb-2"
                      >
                        Your Break time in progress
                      </Dialog.Title>
                    </div>

                    <div className="flex flex-col justify-center items-center gap-1 mt-1">
                      <p className="text-[26px] font-semibold text-gray-700">
                        You are on Break
                      </p>
                      <p className="text-[18px] text-gray-500">Login Back</p>
                    </div>
                    <div className="flex justify-center mt-2">
                      <button
                        className="bg-[var(--bg-base-color)] hover:opacity-90 text-white font-semibold px-8 py-2.5 rounded-full transition duration-200 shadow-md"
                        type="submit"
                        onClick={loginHandler}
                      >
                        Login
                      </button>
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition.Root>
        <Transition.Root show={checked} as={Fragment}>
          <Dialog
            as="div"
            className="relative z-[99]"
            initialFocus={cancelButtonRef}
            onClose={change}
          >
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-black bg-opacity-25 transition-opacity" />
            </Transition.Child>

            <div className="fixed inset-0 z-[99] w-screen mx-auto overflow-y-auto">
              <div className="flex min-h-full items-center justify-center p-4 text-center">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 scale-95"
                  enterTo="opacity-100 scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 scale-100"
                  leaveTo="opacity-0 scale-95"
                >
                  <Dialog.Panel className="relative w-full max-w-md transform overflow-hidden rounded-2xl bg-white text-left shadow-[0_25px_70px_rgba(0,0,0,0.18)] transition-all border border-gray-100">
                    {/* Header */}
                    <div className="px-6 pt-6 pb-4 text-center border-b border-gray-100">
                      <Dialog.Title
                        as="h3"
                        className="text-[24px] font-semibold text-[var(--bg-base-color)] font-tbPop"
                      >
                        Alert!!!
                      </Dialog.Title>

                      <Dialog.Title
                        as="h3"
                        className="text-[16px] text-gray-500 mt-2 font-tbPop leading-relaxed"
                      >
                        If this is your break time!! Please select break type
                      </Dialog.Title>
                    </div>

                    {/* Form */}
                    <form onSubmit={handleSubmit(submit)}>
                      <div className="px-6 py-6">
                        {/* Rich Select */}
                        <div className="relative">
                          <select
                            id="break_type"
                            value={selectedBreakType}
                            {...register("break_type")}
                            className="w-full appearance-none border border-gray-300 rounded-xl px-4 py-3 text-[14px] bg-gray-50 focus:bg-white focus:ring-2 focus:ring-[var(--bg-base-color)] focus:border-[var(--bg-base-color)] outline-none transition"
                          >
                            <option value="" defaultChecked>
                              Options...
                            </option>

                            <option value="Lunch">Lunch Break</option>
                            <option value="Tea">Tea Break</option>
                            <option value="Loo">Loo Break</option>
                            <option value="Meeting">Meeting Break</option>
                            <option value="sessionLogout">
                              Session LogOut
                            </option>
                          </select>

                          {/* Dropdown Icon */}
                          <div className="absolute inset-y-0 right-3 flex items-center pointer-events-none">
                            <svg
                              className="w-5 h-5 text-gray-400"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M19 9l-7 7-7-7"
                              />
                            </svg>
                          </div>
                        </div>
                      </div>

                      {/* Buttons */}
                      <div className="flex justify-end gap-3 px-6 pb-6">
                        <button
                          className="px-6 py-2 text-sm font-semibold text-white bg-[var(--bg-base-color)] rounded-lg hover:opacity-90 transition shadow-md"
                          type="submit"
                        >
                          Yes
                        </button>

                        <button
                          type="button"
                          className="px-6 py-2 text-sm font-semibold text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-100 transition"
                          onClick={toggle}
                          ref={cancelButtonRef}
                        >
                          No
                        </button>
                      </div>
                    </form>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition.Root>
      </>
    );
}
